import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { Tutor } from "../Common/types";
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useTenant } from "../Routers/TenantContextProvider";


// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}



const TutorManager = () => {
  const [tutors, setTutors] = useState<Tutor[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

   const { tenant, loading, error } = useTenant();

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch tutors when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchTutors();
    }
  }, [selectedTenant]);

  const fetchTutors = async () => {
    if (!selectedTenant) return;
    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/tutors`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setTutors(response.data);
    } catch (error) {
      console.error("Failed to load tutors", error);
    }
  };

  const handleReviewTutor = (tutor_id: number) => {
    // Placeholder function
    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/tutor-manager/review-tutor/${tutor_id}`);
    }
      
  };


  const handleAddNewTutor = () => {

    const tutor_id=0;
    if (tenant)
    {
      navigate(`/platform/${tenant.tenant_slug}/app/tutor-manager/review-tutor/${tutor_id}`);
    }
  };

  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>All Registered Tutors</Heading>
      </VStack>

            <Box mt={4}>
               <Text fontWeight="bold">Tutors Details</Text>
              <Button mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewTutor}>
                + Tutor
              </Button>
      </Box>

      <Box mt={4}>
       
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Name</Th>
              <Th>Gender</Th>
              <Th>DoB</Th>
              <Th>Email</Th>
              <Th>Address</Th>
              <Th>User Id</Th>
              <Th>Created At</Th>
              <Th>Action</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
            {tutors.map((tutor) => (
              <Tr key={tutor.tutor_id}>
                <Td>{tutor.tutor_id}</Td>
                <Td>{`${tutor.given_name} ${tutor.middle_name} ${tutor.surname}`}</Td>
                <Td>{`${tutor.gender}`}</Td>
                    <Td>
                          {tutor.date_of_birth  ? fmtLocal(tutor.date_of_birth , { hour: undefined, minute: undefined }) : 'N/A'}
                        </Td>
                <Td>{`${tutor.email}`}</Td>
                <Td>{`${tutor.address} ${tutor.suburb} ${tutor.postcode}`}</Td>

                <Td>{`${tutor.user_id}`}</Td>
            
                <Td>{fmtLocal(tutor.created_at)}</Td>
                <Td>
                  <Tooltip label="Edit">
                    <Button size="sm" onClick={() => handleReviewTutor(tutor.tutor_id)}>
                      Review Tutor
                    </Button>
                  </Tooltip>
                </Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </Box>

    </Box>
  );
};

export default TutorManager;
